// Safari has buggy iterators w/o `next`
module.exports = 'keys' in [] && !('next' in [].keys());


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.iter-buggy.js
 ** module id = 29
 ** module chunks = 0
 **/